import { render, staticRenderFns } from "./pg-updProfilePicture.vue?vue&type=template&id=12fde585&scoped=true"
import script from "./pg-updProfilePicture.vue?vue&type=script&lang=js"
export * from "./pg-updProfilePicture.vue?vue&type=script&lang=js"
import style1 from "./pg-updProfilePicture.vue?vue&type=style&index=1&id=12fde585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fde585",
  null
  
)

export default component.exports